function convertDateToUTC(date) {
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
}

export default convertDateToUTC



// WEBPACK FOOTER //
// ./src/utility/convertDateToUTC.js